/**
 * The menu card "+" for an item with no options. When the guest is in an
 * active group order the line belongs on the shared server cart (same as
 * ItemDetailScreen's add), never on the guest's private cart, where the rest
 * of the table would never see it.
 */
export interface QuickAddLine {
  itemId: string;
  qty: number;
  notes?: string;
  [k: string]: unknown;
}

export interface QuickAddDeps<L extends QuickAddLine> {
  isMenuOnly: boolean;
  groupActive: boolean;
  addToShortlist: (line: L) => void;
  addToCart: (line: L) => void;
  addGroupLine: (input: {
    catalogItemId: string;
    quantity: number;
    variantSelections: [];
    modifierSelections: [];
    notes: string | null;
  }) => Promise<unknown>;
}

export async function quickAdd<L extends QuickAddLine>(
  line: L,
  deps: QuickAddDeps<L>,
): Promise<void> {
  if (deps.isMenuOnly) {
    deps.addToShortlist(line);
    return;
  }
  if (deps.groupActive) {
    await deps.addGroupLine({
      catalogItemId: line.itemId,
      quantity: line.qty,
      variantSelections: [],
      modifierSelections: [],
      notes: line.notes?.trim() || null,
    });
    return;
  }
  deps.addToCart(line);
}
